import Yggdrasil from 'services/yggdrasil'
import i18n from 'services/i18n'
import { mapGetRibbons, mapGetTimeBasedRibbons } from 'store/shared/collectionHelper'

const state = {
    singleCollection: null,
    selectedSorting: i18n.t('CollectionFilter.alpha_order_asc'),
    collectionsLimit: [],
    collectionPreviewScrollTop: 0
}

const mutations = {
    ASSIGN_SINGLE_COLLECTION (state, collection) {
        state.singleCollection = collection
    },
    SELECT_SORTING (state, option) {
        state.selectedSorting = option
    },
    INCREASE_COLLECTIONS_LIMIT (state, packageLimit) {
        const index = state.collectionsLimit.find(limit => limit.id === packageLimit.id)
        if (index === undefined) {
            state.collectionsLimit.push(packageLimit)
        } else {
            state.collectionsLimit[state.collectionsLimit.findIndex(el => el.id === packageLimit.id)] = packageLimit
        }
    },
    ASSIGN_COLLECTION_PREVIEW_SCROLL_TOP (state, scrollTop) {
        state.collectionPreviewScrollTop = scrollTop
    }
}

const actions = {
    async loadSingleCollection (store, slug) {
        const id = slug.split('-')[0]
        const collection = await Yggdrasil.loadCollectionById(id)
        store.commit('ASSIGN_SINGLE_COLLECTION', collection)
    },
    clearSingleCollection (store) {
        store.commit('ASSIGN_SINGLE_COLLECTION', null)
    },
    selectSorting (store, option) {
        store.commit('SELECT_SORTING', option)
    },
    increaseCollectionsLimit (store, packageLimit) {
        store.commit('INCREASE_COLLECTIONS_LIMIT', packageLimit)
    },
    assignCollectionPreviewScrollTop (store, scrollTop) {
        store.commit('ASSIGN_COLLECTION_PREVIEW_SCROLL_TOP', scrollTop)
    }
}

const getters = {
    getSingleCollection: (state) => state.singleCollection,
    getSingleCollectionCourses: (state, getters) => {
        if (getters.getSingleCollection) {
            return getters.getSingleCollection.items.filter(item => item.type === 'course')
        }
        return []
    },
    getSelectedSorting: state => state.selectedSorting,
    getCollectionsLimitByPackage: (state) => id => state.collectionsLimit.find((limit) => limit.id === id),
    mapCollectionToRibbon: (state) => mapGetRibbons,
    mapCollectionToTimeBasedRibbon: (state) => mapGetTimeBasedRibbons,
    getCollectionPreviewScrollTop: (state) => state.collectionPreviewScrollTop
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
